<template id="report">
  <div>
    <datepicker inline v-model="report.date"></datepicker>
    <ReportItem label="Person 1" :item="report.person1" vvFormScope="person1"></ReportItem>
    <ReportItem label="Person 2" :item="report.person2" vvFormScope="person2"></ReportItem>
    <ReportItem label="Person 3" :item="report.person3" vvFormScope="person3"></ReportItem>
    <ReportItem label="Person 4" :item="report.person4" vvFormScope="person4"></ReportItem>
    <ReportItem label="Person 5" :item="report.person5" vvFormScope="person5"></ReportItem>
    <ReportItem label="Person 6" :item="report.person6" vvFormScope="person6"></ReportItem>
  </div>
</template>
<script>
import ReportItem from './ReportTemplate2Item.vue'
import Datepicker from 'vuejs-datepicker';
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem,
      Datepicker
  }
};
</script>